const parseTierByLevel = (tiers = [], level = 1) => {
  const sortedTiers = tiers.sort((a, b) => a.start - b.start);
  return sortedTiers[level - 1];
};

export default parseTierByLevel;
